<template>
  <div class="page-container">
    <template v-if="contentLoaded">
      <template v-if="!isMobile">
        <!--        <ExampleButtons />-->
        <StartImage v-if="showContent == 0" />
        <Unity v-if="showContent == 30" />
        <ContentManager />
        <IntroAudio v-if="config.has_intro_audio" />
      </template>
      <template v-else>
        <MobileImage />
      </template>
    </template>
  </div>
</template>

<script>
import Unity from "@/components/Unity";
import StartImage from "@/components/StartImage";
import MobileImage from "@/components/MobileImage";
import ContentManager from "@/components/ContentManager";
import ExampleButtons from "@/components/ExampleButtons";
import IntroAudio from "@/components/IntroAudio";
import "@mdi/font/css/materialdesignicons.css";

import { mapState } from "vuex";
export default {
  components: {
    ContentManager,
    IntroAudio,
    StartImage,
    MobileImage,
    Unity,
    ExampleButtons,
  },
  data() {
    return {
      showContent: 0,
    };
  },
  computed: {
    ...mapState(["contentLoaded", "isMobile", "config"]),
  },
  methods: {
    updateContentVisibility(visibility) {
      this.showContent = visibility;
    },
  },
  mounted() {
    this.$eventBus.$on("updateContentVisibility", this.updateContentVisibility);
    this.$store.dispatch("load_json");

    // setTimeout(() => {
    //   this.$store.dispatch("set_popup", 2);
    // }, 900);
  },
};
</script>
